import { GlassCard } from '@/components/design/GlassCard';
import { Users, FileText, Target, Shield } from 'lucide-react';

const activities = [
  {
    id: 1,
    user: 'Sarah Johnson',
    action: 'completed level',
    target: 'Corporate Ladder',
    time: '2 mins ago',
    icon: Target,
    color: 'text-blue-400',
  },
  {
    id: 2,
    user: 'Mike Chen',
    action: 'posted in',
    target: 'Economic Policy Discussion',
    time: '15 mins ago',
    icon: FileText,
    color: 'text-purple-400',
  },
  {
    id: 3,
    user: 'New User',
    action: 'joined the platform',
    target: '',
    time: '1 hour ago',
    icon: Users,
    color: 'text-green-400',
  },
  {
    id: 4,
    user: 'Admin System',
    action: 'detected anomaly',
    target: 'Login Attempts',
    time: '2 hours ago',
    icon: Shield,
    color: 'text-red-400',
  },
];

export const ActivityFeed = () => {
  return (
    <GlassCard className="h-full">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold">Live Activity</h3>
        <span className="flex h-2 w-2 relative">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
        </span>
      </div>

      <div className="space-y-6">
        {activities.map((activity, i) => (
          <div key={activity.id} className="flex gap-4 relative">
            {i !== activities.length - 1 && (
              <div className="absolute left-[19px] top-10 bottom-[-24px] w-[2px] bg-white/5" />
            )}
            
            <div className={`relative z-10 w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center ${activity.color}`}>
              <activity.icon className="w-5 h-5" />
            </div>
            
            <div className="flex-1 pt-1">
              <p className="text-sm">
                <span className="font-semibold text-white">{activity.user}</span>
                <span className="text-muted-foreground mx-1">{activity.action}</span>
                <span className="text-primary">{activity.target}</span>
              </p>
              <p className="text-xs text-muted-foreground mt-1">{activity.time}</p>
            </div>
          </div>
        ))}
      </div>
    </GlassCard>
  );
};
